import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScatterplotTrainingDataIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 12h14M12 5v14",
		stroke: "currentColor",
		strokeWidth: 2.4
	})
});
export default SvgScatterplotTrainingDataIcon;
